/** Learn's map: the map itself. */
export const LEARN_MAP_PATHNAME = "/learn/map";

/** The map, or a page opened from it (a character's panels at `/learn/map/morpheme/…`). */
export function isLearnMapPathname(pathname: string): boolean {
  return pathname === LEARN_MAP_PATHNAME || pathname.startsWith(`${LEARN_MAP_PATHNAME}/`);
}
